import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';
import { TypeProfileDTO, TypeProfilePostDTO } from '@app/src/views/StepPayment/formPayment/dtos';

export const hydrateData = (data: TypeProfileDTO) => ({
  id: data.id,
  documentType: data.document_type,
  documentNumber: data.document_number,
  name: data.first_name,
  motherLastName: data.mother_last_name,
  fatherLastName: data.father_last_name,
  phone: data.phone_number,
  email: data.email,
  businessName: data.business_name,
  address: data.address,
  districtId: data.district_id,
  deparmentId: data.department_id
} as TypeProfileModel)

export const hydrateDataPost = (data) => ({
  business_name: '',
  first_name: data.name,
  father_last_name: data.fatherLastName,
  mother_last_name: data.motherLastName,
  document_type: 'DNI',
  document_number: data.dni,
  phone_number: data.phone,
  email: data.email,
  adecsys_customer: '',
  department_id: 1,
  district_id: null,
  address: data.address,
  location: ''
} as TypeProfilePostDTO)

export const hydrateDataPut = (data) => ({
  email: data.email,
  phone_number: data.phone
} as TypeProfilePostDTO)